import React, { useState, useEffect } from "react"

import { connect } from 'react-redux';
import { useHistory, withRouter, useParams } from "react-router-dom";

import DeleteIcon from "@material-ui/icons/Delete"
import DeleteOutlined from "@material-ui/icons/DeleteOutlined"
import EditIcon from "@material-ui/icons/Edit"
import SearchIcon from "@material-ui/icons/Search"
import CloseIcon from "@material-ui/icons/Close"
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { TextField, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, Paper, InputAdornment, TablePagination, MenuItem, Select, Box } from "@material-ui/core";

import { ConfirmationHandler } from "dsilo-ui-components";

import { Loader } from '../../loader';
import { PUBLIC_PATH } from "../../../constants"
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { getDataModelById, getContractDataById, getSubModelData, clearReduxDataOfCurrentComponent, updateDataModelData, deleteContractPDFAction } from '../../../store/actions';
import { validateAccessControlResponse } from '../../../utility/AbilityCheck'; // Import ability function

import useStyles from "../styles";

const ClauseList = (props) => {
    const classes = useStyles()
    const history = useHistory();
    const {isNewV1Theme} = props;
    const { id: _id } = useParams();

    const { setIsClauseView, allDataElementforClause, setAllDataElementsforClause, state, setState, setTableData, tableData, setSearchedText, searchedText, sharedJSON } = props
    const { isAccessControl, setIsAccessControl } = props
    const { chartData, chartUniqueId } = props.data
    const { pagination, subDataElement } = chartData
    // const [searchedText, setSearchedText] = useState('');
    const [fetched1, setFetched1] = useState(false)
    const [tempPageInput, setTempPageInput] = useState(1)

    const [deleteConfirmState, setDeleteConfirm] = useState({
        isOpen: false,
        deleteMessage: "Are you sure you want to delete ?",
        data: null
    })
    
    // const tableData = props.formData?.document[chartUniqueId + "_data"]
    const count = props.formData?.document[chartUniqueId + "_data"]?.total
    const loading = props?.formData?.[chartUniqueId + '_data' + '_loading']
    let dataUniqueId = chartData.subDataModel
    let mainDataModelDataElement = props?.formData?.dataModel?.[dataUniqueId]?.mainDataModel?.dataElement
    let dataUniqueIdofclause = chartData.subDataModel;

    useEffect(() => {
        if (props.formData?.dataModel?.[dataUniqueIdofclause]) {
            let dataElementsList = props.formData?.dataModel?.[dataUniqueIdofclause]?.dataElements || []
            let obj = {}
            dataElementsList.forEach(de => {
                obj[de.name] = de
            })
            setAllDataElementsforClause(obj)
        }
    }, [props.formData?.dataModel])

    // useEffect(() => {
    //     if (props.formData?.document[chartUniqueId + "_data"]) {
    //         let data = props.formData?.document[chartUniqueId + "_data"];
    //         if (data && data?.data && data?.data?.length > 0) {
    //             setTableData(data.data)
    //         }
    //         if (data && data.errorInfo) {
    //             validateAccessControlResponse(data.errorInfo, setIsAccessControl)
    //             // setNoData(true)
    //             // setErrorMsg(document?.[chartUniqueId + "data"]?.message)
    //         }
    //     }
    // }, [props.formData?.document[chartUniqueId + "_data"]])

    useEffect(() => {
        let dataUniqueId = chartData.subDataModel;
        let dataModelId = chartData.subDataModel
        if (!props.formData?.dataModel?.[dataUniqueId] && !props.formData[`${dataUniqueId}_loading}`]) {
            let payload = {
                appid: props.match.params.appid,
                orgId: props.appConfig?.org?._id,
                dataModelId: dataModelId,
                dataUniqueId: dataUniqueId
            };
            props.getDataModelById(payload);
        }
    }, [])

    useEffect(() => {
        if (state?.paginationPage !== undefined) {
            setTempPageInput(state.paginationPage + 1);
        }
    }, [state?.paginationPage])

    // useEffect(() => {
    //     let dataUniqueId = chartData.subDataModel;
    //     const dataModelEntry = props?.formData?.dataModel?.[dataUniqueId];
    //     if (dataModelEntry?.mainDataModel) {
    //         fetchData();
    //     }
    // }, [props?.formData?.dataModel, state.paginationPage, state.rowsPerPage, _id]);

    useEffect(() => {
        return () => {
            let subKeys = [
                chartUniqueId + '_data',
            ]

            props.clearReduxDataOfCurrentComponent({
                key: "document",
                subKey: subKeys
            })
        }
    }, [])

    const tableCrudOperations = (item, type, e) => {
        if (type === 'delete') {
            setDeleteConfirm({
                ...deleteConfirmState,
                isOpen: true,
                data: item._id
            })
        }
        if (type === "edit") {
            history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/page/${props.page.url}/${_id}/sd/${item._id}`
            })
            setIsClauseView(true)
        }
        if (type === "add") {
            history.push({
                pathname: `/${PUBLIC_PATH}${props.match.params.appid}/page/${props.page.url}/${_id}/sd/new`
            })
            setIsClauseView(true)
        }
    }

    const searchHandler = (e) => {
        setSearchedText(e ? e.target.value : "")
    }

    const onSearchEnter = (e, onSearchButton = false) => {
        if (e === null) {
            setSearchedText('')
            fetchData("")
        } else if (e?.keyCode === 13 || onSearchButton) {
            fetchData(searchedText)
        }
    }

    const handleSearchClick = (type) => {
        setState((prevState) => {
            if (!prevState) {
                return sharedJSON || {}
            }
            const newState = { ...prevState, isSearchIconHide: !prevState.isSearchIconHide };

            if (!newState.isSearchIconHide && type === "close" && searchedText) {
                onSearchEnter(null);
            }
            return newState
        })
    }

    const handleChangeRowsPerPage = (event) => {
        setFetched1(true)
        setState(prev => {
            return {
                ...prev,
                rowsPerPage: event.target.value,
                paginationPage: 0
            }
        })
        setTempPageInput(1)
    }

    const handleChangePage = (event, page) => {
        setFetched1(true)
        setState(prev => {
            return {
                ...prev, paginationPage: page
            }
        })
        setTempPageInput(page + 1)
    }

    const getPageNo = () => {
        if (state?.paginationPage !== undefined) {
            return state.paginationPage;
        }
        return 0;
    };

    const getRowsPerPage = () => {
        return Number(state?.rowsPerPage) || 10;
    };

    const getCurrentPage = () => {
        return state?.paginationPage || 0;
    };

    const fetchData = (searchTextData) => {
        const payload = {
            appId: props.match.params.appid,
            dataModelId: chartData.subDataModel,
            dataUniqueId: chartUniqueId + "_data",
            fields: subDataElement.map((i) => i.value).join(","),
            [mainDataModelDataElement]: _id
        }
        payload.page = state?.paginationPage || 0;
        payload.rowsPerPage = state?.rowsPerPage || 10;
        if (searchTextData !== undefined) {
            payload.search = searchTextData;
        } else if (searchedText) {
            payload.search = searchedText;
        }
        props.getSubModelData(payload)
    }

    const onDeleteResponse = (isDelete) => {
        if (isDelete) {
            const payload = {
                ids: { ids: [deleteConfirmState.data] },
                dataModelId: chartData.subDataModel,
                appId: props.match.params.appid,
                dataUniqueId: props.data.chartUniqueId + '_data'
            }
            props.deleteContractPDFAction(payload)
        }
        setDeleteConfirm({ ...deleteConfirmState, isOpen: false, data: null })
    }
    const [openActionRowId, setOpenActionRowId] = useState(null);

    const handleToggleActions = (rowId, e) => {
    e.stopPropagation();
    setOpenActionRowId((prevId) => (prevId === rowId ? null : rowId));
    };

    return (
    <div>
    {!isNewV1Theme ? ( 
        <>
            <div className={classes.clauseList}>
                <h2>{props.page.listTitle}</h2>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {props.isSearch
                        && <TextField
                            id="standard-basic"
                            label="Search"
                            variant="outlined"
                            value={searchedText}
                            onChange={searchHandler}
                            onKeyDown={onSearchEnter}
                            size="small"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {state?.isSearchIconHide ? (
                                            <IconButton
                                                title="Cancel"
                                                onClick={() => handleSearchClick("close")}
                                                style={{ padding: 0 }}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        ) : (
                                            <IconButton
                                                title="Search"
                                                onClick={(e) => {
                                                    onSearchEnter(e, true);
                                                    handleSearchClick("search");
                                                }}
                                                style={{ padding: 0 }}
                                            >
                                                <SearchIcon color="primary" />
                                            </IconButton>
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                    <Button variant="contained" color="primary" size='small' style={{ marginLeft: "10px" }} onClick={(e) => tableCrudOperations(null, "add", e)}>+ CREATE CLAUSE</Button>
                </div>
            </div>
            <div>
                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow className={classes.tableHeadRow}>
                                {chartData?.subDataElement?.map((header, index) => (
                                    <TableCell key={index} className={classes.tableHeadCell}>
                                        {header.label || header.value}
                                    </TableCell>
                                ))}
                                <TableCell className={classes.tableHeadCell}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={chartData?.subDataElement?.length + 1} align="center">
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                tableData?.length > 0 ? (
                                    tableData?.map((row, rowIndex) => {
                                        return (
                                            <TableRow
                                                key={row._id || rowIndex}
                                                className={`${classes.tableRow} ${rowIndex % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}`}
                                            >
                                                {chartData?.subDataElement?.map((header, colIndex) => {
                                                    const de = allDataElementforClause?.[header.value];
                                                    const type = de?.type;
                                                    const blocks = row?.[`${header.value}.blocks`];
                                                    const value = row?.[header.value] || "-";

                                                    return (
                                                        <TableCell key={colIndex} className={classes.tableCell}>
                                                            {
                                                                type === 'wysiwyg' && Array.isArray(blocks) && blocks.length > 0 ? (
                                                                    blocks.map((block, index) => (
                                                                        block?.text ? (
                                                                            block.text.replace(/\\n/g, '\n').split('\n').map((textLine, lineIndex) => (
                                                                                <div key={`${index}-${lineIndex}`}>
                                                                                    {textLine}
                                                                                </div>
                                                                            ))
                                                                        ) : null
                                                                    ))
                                                                ) : value
                                                            }

                                                        </TableCell>
                                                    );
                                                })}

                                                <TableCell className={classes.tableCell}>
                                                    <div className={classes.actionsContainer}>
                                                        <IconButton className={classes.actionIcons} onClick={(e) => tableCrudOperations(row, "edit", e)}>
                                                            <Tooltip title="Edit">
                                                                <EditIcon />
                                                            </Tooltip>
                                                        </IconButton>
                                                        <IconButton className={classes.actionIcons} onClick={(e) =>
                                                            tableCrudOperations(row, "delete", e)
                                                        }>
                                                            <Tooltip title="Delete">
                                                                <DeleteIcon />
                                                            </Tooltip>
                                                        </IconButton>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={chartData?.subDataElement?.length + 1} align="center">
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                )
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={
                        pagination?.rowsPerPageOptions || [
                            10, 25, 50, 100
                        ]
                    }
                    component='div'
                    count={count || 0}
                    style={{
                        color: "rgba(0, 0, 0, 0.87)",
                        position: "sticky",
                        bottom: 0,
                        background: "#fff",
                        zIndex: 1000,
                    }}
                    rowsPerPage={Number(state?.rowsPerPage) || 10}
                    page={getPageNo()}
                    backIconButtonProps={{
                        "aria-label": "Previous Page"
                    }}
                    nextIconButtonProps={{
                        "aria-label": "Next Page"
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
            <ConfirmationHandler
                open={deleteConfirmState.isOpen}
                handleClose={onDeleteResponse}
                alertMessageText={deleteConfirmState.deleteMessage}
                classes={classes}
                confirm
            />
        </>
    ) : (
        <>
        <div className={classes.newclauseList}>
        <h2 style={{fontWeight: 500}}>{props.page.listTitle}</h2>
        <div style={{ display: "flex", alignItems: "center" }}>
            {props.isSearch
                && <TextField
                    id="standard-basic"
                    label="Search"
                    variant="outlined"
                    value={searchedText}
                    onChange={searchHandler}
                    onKeyDown={onSearchEnter}
                    size="small"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {state.isSearchIconHide ? (
                                    <IconButton
                                        title="Cancel"
                                        onClick={() => handleSearchClick("close")}
                                        style={{ padding: 0 }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                ) : (
                                    <IconButton
                                        title="Search"
                                        onClick={(e) => {
                                            onSearchEnter(e, true);
                                            handleSearchClick("search");
                                        }}
                                        style={{ padding: 0 }}
                                    >
                                        <SearchIcon color="primary" />
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            }
            <Button variant="contained" className={classes.update} style={{ marginLeft: "10px", minHeight: "40px" }} onClick={(e) => tableCrudOperations(null, "add", e)}>+ CREATE CLAUSE</Button>
        </div>
        </div>
        <div>
        <TableContainer component={Paper} className={classes.themetableContainer}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow className={classes.themeTableHeadRow}>
                        {chartData?.subDataElement?.map((header, index) => (
                            <TableCell key={index} className={classes.themetableHeadCell}>
                                {header.label || header.value}
                            </TableCell>
                        ))}
                        <TableCell className={classes.themetableHeadCell}>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? (
                        <TableRow>
                            <TableCell colSpan={chartData?.subDataElement?.length + 1} align="center">
                                <Loader />
                            </TableCell>
                        </TableRow>
                    ) : (
                        tableData?.length > 0 ? (
                            tableData?.map((row, rowIndex) => {
                                return (
                                    <TableRow
                                        key={row._id || rowIndex}
                                        className={classes.themetableRow}
                                    >
                                        {chartData?.subDataElement?.map((header, colIndex) => {
                                            const de = allDataElementforClause?.[header.value];
                                            const type = de?.type;
                                            const blocks = row?.[`${header.value}.blocks`];
                                            const value = row?.[header.value] || "-";

                                            return (
                                                <TableCell key={colIndex} className={classes.themetableCell}>
                                                    {
                                                        type === 'wysiwyg' && Array.isArray(blocks) && blocks.length > 0 ? (
                                                            blocks.map((block, index) => (
                                                                block?.text ? (
                                                                    block.text.replace(/\\n/g, '\n').split('\n').map((textLine, lineIndex) => (
                                                                        <div key={`${index}-${lineIndex}`}>
                                                                            {textLine}
                                                                        </div>
                                                                    ))
                                                                ) : null
                                                            ))
                                                        ) : value
                                                    }

                                                </TableCell>
                                            );
                                        })}

                                        <TableCell className={classes.themetableCell}>
                                            <div className={classes.actionsContainer} style={{justifyContent: 'center'}}>
                                                <IconButton
                                                className={classes.themeactionIcons}
                                                onClick={(e) => handleToggleActions(row._id, e)}
                                                >
                                                <Tooltip title="Actions">
                                                    <MoreVertIcon />
                                                </Tooltip>
                                                </IconButton>

                                                <section
                                                className={`${classes.actionBtnContent} ${
                                                    openActionRowId === row._id ? "active" : ""
                                                }`}
                                                >
                                                <Box className={classes.buttonBox}
                                                onClick={(e) => tableCrudOperations(row, "edit", e)}>
                                                    <IconButton
                                                    className={classes.themeactionIcons}
                                                    
                                                    >
                                                    <Tooltip title="Edit">
                                                        <EditIcon />
                                                    </Tooltip>
                                                    </IconButton>
                                                    <span>Edit</span>
                                                </Box>

                                                <Box className={classes.buttonBox}
                                                onClick={(e) => tableCrudOperations(row, "delete", e)}>
                                                    <IconButton
                                                    className={classes.themeactionIcons}
                                                    
                                                    >
                                                    <Tooltip title="Delete">
                                                        <DeleteOutlined />
                                                    </Tooltip>
                                                    </IconButton>
                                                    <span>Delete</span>
                                                </Box>
                                                </section>
                                            </div>
                                            </TableCell>

                                    </TableRow>
                                )
                            }

                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={chartData?.subDataElement?.length + 1} align="center">
                                    No data available
                                </TableCell>
                            </TableRow>
                        )
                    )}
                </TableBody>
            </Table>
        </TableContainer>
     
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 12
        }}>
            {/* Left side - Rows per page */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '12px', color: '#616161' }}>Rows per page:</span>
                <Select
                    value={getRowsPerPage()}
                    onChange={handleChangeRowsPerPage}
                    className={classes?.paginationSelect}
                    inputProps={{
                        'data-testid': `${chartUniqueId}_custom-select-id`,
                        id: `${chartUniqueId}_rowPerPage`
                    }}
                    disableUnderline
                >
                    {(pagination?.rowsPerPageOptions || [10, 15, 25, 50, 100]).map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
                <span style={{ fontSize: '12px', color: '#212121' }}>
                    {`${getCurrentPage() * getRowsPerPage() + 1}-${Math.min((getCurrentPage() + 1) * getRowsPerPage(), count || 0)} of ${count || 0}`}
                </span>
            </div>

            {/* Right side - Page navigation */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '12px', color: '#616161' }}>Goto page:</span>
                <TextField
                    type="number"
                    value={tempPageInput}
                    onChange={(e) => {
                        // Only allow numbers
                        const value = e.target.value;
                        // Handling the empty and max page value in the input field
                        if (value === "" || (value >= 1 && value <= Math.ceil((count || 0) / getRowsPerPage()))) {
                            setTempPageInput(value);
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            const page = parseInt(e.target.value) - 1;
                            if (page >= 0 && page < Math.ceil((count || 0) / getRowsPerPage())) {
                                handleChangePage(null, page);
                                setTempPageInput(page + 1);
                            }
                            e.target.blur(); // Remove focus after Enter
                        }
                    }}
                    onBlur={(e) => {
                        // Reset to current page if invalid input
                        const value = e.target.value;
                        const page = parseInt(value) - 1;
                        if (value === '' || isNaN(page) || page < 0 || page >= Math.ceil((count || 0) / getRowsPerPage())) {
                            setTempPageInput(getCurrentPage() + 1);
                        }
                    }}
                    className={classes?.pagination}
                    style={{
                        width: '55px !important'
                    }}
                    inputProps={{
                        style: {
                            textAlign: 'center',
                            fontSize: '14px'
                        }
                    }}
                />
                <span style={{ fontSize: '12px', color: '#212121' }}>
                    {`of ${Math.ceil((count || 0) / getRowsPerPage())}`}
                </span>

                {/* Navigation buttons */}
                <div style={{ display: 'flex', gap: '4px', marginLeft: '8px' }}>
                    <IconButton
                        onClick={() => {
                            handleChangePage(null, 0);
                            setTempPageInput(1);
                        }}
                        disabled={getCurrentPage() === 0}
                        size="small"
                        title="First page"
                        className={classes.iconButton}
                    >
                        <FirstPageIcon style={{ fontSize: '16px' }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            const newPage = getCurrentPage() - 1;
                            handleChangePage(null, newPage);
                            setTempPageInput(newPage + 1);
                        }}
                        disabled={getCurrentPage() === 0}
                        size="small"
                        title="Previous page"
                    >
                        <KeyboardArrowLeft style={{ fontSize: '16px' }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            const newPage = getCurrentPage() + 1;
                            handleChangePage(null, newPage);
                            setTempPageInput(newPage + 1);
                        }}
                        disabled={getCurrentPage() >= Math.ceil((count || 0) / getRowsPerPage()) - 1}
                        size="small"
                        title="Next page"
                    >
                        <KeyboardArrowRight style={{ fontSize: '16px' }} />
                    </IconButton>
                    <IconButton
                        onClick={() => {
                            const lastPage = Math.ceil((count || 0) / getRowsPerPage()) - 1;
                            handleChangePage(null, lastPage);
                            setTempPageInput(lastPage + 1);
                        }}
                        disabled={getCurrentPage() >= Math.ceil((count || 0) / getRowsPerPage()) - 1}
                        size="small"
                        title="Last page"
                    >
                        <LastPageIcon style={{ fontSize: '16px' }} />
                    </IconButton>
                </div>
            </div>
        </div>
                            
        </div>
        <ConfirmationHandler
        open={deleteConfirmState.isOpen}
        handleClose={onDeleteResponse}
        alertMessageText={deleteConfirmState.deleteMessage}
        classes={classes}
        confirm
        />
        </>
    )}
    </div>
    )
}

const mapDispatchToProps = {
    getDataModelById,
    getContractDataById,
    getSubModelData,
    clearReduxDataOfCurrentComponent,
    updateDataModelData,
    deleteContractPDFAction

}

const mapStateToProps = state => {
    return {
        formData: state.form,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClauseList))